module.exports = __webpack_public_path__ + "static/img/stopIcon.b2bea0e2.svg";